import type {
  PrivacyCookie,
  PrivacyService,
} from "../types";



export function getAllCookies(
  services: PrivacyService[]
): PrivacyCookie[] {

  return services.flatMap(
    service =>
      service.cookies ?? []
  );

}




export function getCookiesByCategory(
  services: PrivacyService[],
  category: string
): PrivacyCookie[] {

  return getAllCookies(
    services
  ).filter(
    cookie =>
      cookie.category === category
  );

}




export function getCookiesByProvider(
  services: PrivacyService[],
  provider:string
):PrivacyCookie[] {

  return getAllCookies(
    services
  ).filter(
    cookie =>
      cookie.provider === provider
  );

}





function matchesCookiePattern(
  cookieName: string,
  pattern: string
): boolean {


  const regex =
    new RegExp(
      "^" +
      pattern.replace(
        /\*/g,
        ".*"
      )
      +
      "$"
    );


  return regex.test(
    cookieName
  );

}





export function removeCookiesByCategory(
  services: PrivacyService[],
  category: string
){


  const cookies =
    getCookiesByCategory(
      services,
      category
    );



  cookies.forEach(
    cookie => {


      if(cookie.pattern){

        removeCookiesByPattern(
          cookie.pattern
        );

      }



      if(cookie.name){

        removeCookie(
          cookie.name
        );

      }


    }
  );

}





function removeCookie(
  name:string
){


  const expires =
    "Thu, 01 Jan 1970 00:00:00 GMT";



  const hostname =
    window.location.hostname;



  const cookieVariants = [

    `${name}=; expires=${expires}; path=/;`,

    `${name}=; expires=${expires}; path=/; domain=${hostname};`,

    `${name}=; expires=${expires}; path=/; domain=.${hostname};`

  ];



  cookieVariants.forEach(
    value => {

      document.cookie =
        value;

    }
  );

}





function removeCookiesByPattern(
  pattern:string
){

  const cookies =
    document.cookie
      .split(";")
      .map(
        cookie =>
          cookie.trim()
      )
      .filter(
        cookie =>
          cookie.length > 0
      )
      .map(
        cookie =>
          cookie.split("=")[0]
      );


  cookies.forEach(
    cookieName => {


      if(
        matchesCookiePattern(
          cookieName,
          pattern
        )
      ){


        removeCookie(
          cookieName
        );


      }


    }
  );

}